import { Directive, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ModalService } from './modal.service';

export interface ModalContext {}

@Directive({ selector: '[modal]' })
export class ModalDirective implements OnInit, OnDestroy {
  private key: {};

  constructor(
    private readonly modalService: ModalService,
    private readonly template: TemplateRef<ModalContext>,
  ) {}

  ngOnInit() {
    this.key = this.modalService.addModal(this.template);
  }

  ngOnDestroy() {
    this.modalService.removeModal(this.key);
  }
}
